import { useRef, type ChangeEvent } from "react";
import { Button } from "@/components/ui/Button";
export function SampleFileButton({label,accept,multiple,disabled,onChange}:{label:string;accept:string;multiple?:boolean;disabled?:boolean;onChange:(event:ChangeEvent<HTMLInputElement>)=>void}) {
  const input=useRef<HTMLInputElement>(null);
  return <><Button type="button" variant="secondary" size="sm" disabled={disabled} onClick={()=>input.current?.click()}>{label}</Button>
    <input ref={input} type="file" accept={accept} multiple={multiple} disabled={disabled} aria-label={label} className="hidden" aria-hidden="true" tabIndex={-1} onChange={onChange}/></>;
}
